import styled from 'styled-components'

import { SearchElement } from '@application/Interfaces/Features/SearchElement'
import { WidgetElement } from '@application/Interfaces/Features/WidgetElement'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    padding-top: 94px;
    background-color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'p600' : 'white']};

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 158px;
    }
`

export const HeadingContainer = styled.div`
    padding-left: 30px;
    padding-right: 30px;
    max-width: 1030px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`

export const Title = styled.div<{ $mode: ThemeModeType }>`
    font-size: 16px;
    color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g500' : 'white']};
    ${(props) => props.theme.fontWeight.regular};
    text-transform: uppercase;
    word-break: break-word;
    margin-bottom: 10px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
    }
`

export const Description = styled.div<{ $mode: ThemeModeType }>`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g600' : 'white']};
    margin-bottom: 20px;

    .highlight {
        color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'p500' : 'a500']};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
    }
`

export const SubDescription = styled.div<{ $mode: ThemeModeType }>`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.light};
    color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'black' : 'white']};
    margin-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM};
        margin-bottom: 30px;
    }
`

export const Widget = styled(WidgetElement)`
    margin-bottom: 50px;

    form {
        ${(props) => props.theme.boxShadow.level4};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 100px;
    }
`

export const Search = styled(SearchElement)`
    margin-bottom: 50px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 100px;
    }
`

export const ImageWrapper = styled.div`
    text-align: center;
`
